/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcphosted_Hub_TitleInputs */

const en_mcphosted_hub_title = /** @type {(inputs: Mcphosted_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wherever you already chat`)
};

const id_mcphosted_hub_title = /** @type {(inputs: Mcphosted_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di mana pun kamu mengobrol`)
};

/**
* | output |
* | --- |
* | "Wherever you already chat" |
*
* @param {Mcphosted_Hub_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mcphosted_hub_title = /** @type {((inputs?: Mcphosted_Hub_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcphosted_Hub_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mcphosted_hub_title(inputs)
	return en_mcphosted_hub_title(inputs)
});